import React from 'react';
import { hashHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import LayoutSwitcher from '../components/LayoutSwitcher';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import { humanFileSize } from '../../../components/utils/format';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import {
  uploadUserFiles,
  getUserFile,
  updateCss,
  changeTenant
} from '../../../store/current-user/CurrentUserActions';
import CSSForm from '../components/CSSForm';
import { requestTenants } from '../../../store/tenant/TenantActions';
import TenantDropdown from '../../../components/common/TenantDropdown';
import { WidgetGrid, JarvisWidget } from '../../../components';
import { isSuperAdmin } from '../../../store/current-user/CurrentUserSelectors';

class Profile extends React.Component {
  constructor() {
    super();
    this.state = {
      files: [],
      showUpload: false,
      fileName: null,
      fileType: null,
    };
  }

  componentDidMount() {
    if (this.props.user.data.photo != null) {
      this.previewFile(this.props.user.data.photo);
    }
  }

  onDrop(files) {
    const filesToAdd = _.difference(files, this.state.files);
    this.setState({ files: this.state.files.concat(filesToAdd) });
  }

  onCancel() {
    this.setState({
      files: [],
    });
  }

  showModal() {
    this.setState({ showUpload: true });
  }

  closeModal() {
    this.setState({ showUpload: false });
    this.onCancel();
  }

  removeFileFromUploadList(fileName) {
    this.setState({ files: this.state.files.filter((file) => (file.name !== fileName)) });
  }

  onStartUpload() {
    this.props
      .uploadFiles(
        this.props.user.data.id,
        this.state.files
      )
      .then(result => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('Files have been uploaded.');
          var filename = this.state.files[0];
          this.setState({ showUpload: false, files: [] });
          this.previewFile(filename.name);
        }
      });
  }

  downloadFile(fileName) {
    this.props
      .getUserFile(
        this.props.user.data.id,
        fileName,
      )
      .then(response => {
        const blob = response.payload;
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  previewFile(filename) {
    this.props
      .getUserFile(
        this.props.user.data.id,
        filename,
    )
      .then(response => {
        const blob = response.payload;
        var type = filename.substring(filename.lastIndexOf('.') + 1, filename.length);
        this.setState({ fileName: URL.createObjectURL(blob) });
        this.setState({ fileType: type });
      });
  }
  
  onFormSubmit = values => {
    this.props
      .updateCss(values.id, values.asset)
      .then(result => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Css has been saved.');
          window.location.reload();
        }
      });
  };

  render() {
    const { user: { data: userInfo, isFilesUploading, isLoading }, isSuperAdmin, tenants, changeTenant } = this.props;
    const primaryClinic = userInfo.clinics ? userInfo.clinics.filter((el) => el.isPrimary).map(el => el.name).join() : null;
    const otherClicnics = userInfo.clinics ? userInfo.clinics.filter((el) => !el.isPrimary).map(el => el.name).join() : null;
    const clients = userInfo.clients ? userInfo.clients.map(el => el.name).join() : null;

    const filesToUpload = this.state.files.map(file => (
      <li className="list-group-item" key={file.name}>
        <span className="filename">{file.name}</span>
        <a
          className="action btn btn-xs btn-danger"
          onClick={() => this.removeFileFromUploadList(file.name)}
        >
          <i className="fa fa-close" />
        </a>
        <span className="badge">{humanFileSize(file.size)} bytes</span>
      </li>
    ));

    const acceptedFiles =
      'image/jpeg, image/png, image/gif, image/x-icon';

    return (
      <div id="content">
        <div className="row">
          <div className="col-sm-12">
            <div className="">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="well well-light well-sm no-margin no-padding">
                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          id="myCarousel"
                          className="carousel fade profile-carousel"
                        >
                          <div className="air air-bottom-right padding-10 hide">
                            &#xA0;
                            <Link to="user-edit" className="btn txt-color-white bg-color-pinkDark btn-sm">
                              <i className="fa fa-pencil" />{' '}
                              Edit
                            </Link>
                          </div>
                          <div className="air air-top-left padding-10">
                            <h4 className="txt-color-white font-md">
                              {/* Jan 1, 2014 */}
                            </h4>
                          </div>
                          <ol className="carousel-indicators">
                            <li
                              data-target="#myCarousel"
                              data-slide-to="0"
                              className="active"
                            />
                            <li
                              data-target="#myCarousel"
                              data-slide-to="1"
                            />
                            <li
                              data-target="#myCarousel"
                              data-slide-to="2"
                            />
                          </ol>
                          <div className="carousel-inner">
                            <div className="item active">
                              <img
                                src="assets/img/demo/s1.jpg"
                                alt="demo user"
                              />
                            </div>
                            <div className="item">
                              <img
                                src="assets/img/demo/s2.jpg"
                                alt="demo user"
                              />
                            </div>
                            <div className="item">
                              <img
                                src="assets/img/demo/m3.jpg"
                                alt="demo user"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-sm-12">
                        <div className="row">
                          <div className="col-sm-3 profile-pic">
                            <img
                              src={(this.state.fileName == null) ? "assets/img/avatars/sunny.png" : this.state.fileName}
                              alt="demo user"
                              onClick={this.showModal.bind(this)}
                            />
                          </div>
                          <Modal show={this.state.showUpload}>
                            <Modal.Header>
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-hidden="true"
                                onClick={this.closeModal.bind(this)}
                              >
                                &times;
                          </button>
                              <h4 className="modal-title" id="addFilesModalLabel">
                                Add Files
                          </h4>
                            </Modal.Header>
                            <Modal.Body>
                              <div className="row client-files-upload">
                                <div
                                  className={
                                    this.state.files.length > 0
                                      ? 'col-sm-12'
                                      : 'col-sm-12'
                                  }
                                >
                                  <Dropzone
                                    accept={acceptedFiles}
                                    onDrop={this.onDrop.bind(this)}
                                    onFileDialogCancel={this.onCancel.bind(this)}
                                  >
                                    {({
                                      getRootProps,
                                      getInputProps,
                                      isDragActive,
                                    }) => {
                                      return (
                                        <div
                                          {...getRootProps()}
                                          className={classNames(
                                            'dropzone dropzone-client-files',
                                            { 'dropzone--isActive': isDragActive },
                                          )}
                                        >
                                          <input {...getInputProps()} />
                                          {isDragActive ? (
                                            <p>Drop files here...</p>
                                          ) : (
                                              <span className="text-center">
                                                <span className="font-lg visible-xs-block visible-sm-block visible-lg-block">
                                                  <span className="font-lg">
                                                    Drop files{' '}
                                                    <span className="font-xs">
                                                      to upload
                                              </span>
                                                  </span>
                                                  <span>
                                                    &nbsp;&nbsp;
                                              <h4 className="display-inline">
                                                      {' '}
                                                (Or Click)
                                              </h4>
                                                  </span>
                                                </span>
                                              </span>
                                            )}
                                        </div>
                                      );
                                    }}
                                  </Dropzone>
                                </div>
                                {this.state.files.length > 0 && (
                                  <div className="col-sm-12">
                                    <h4>Files to be uploaded</h4>
                                    <ul className="list-group files-upload-list">
                                      {filesToUpload}
                                    </ul>
                                    {` `}
                                    {/* {this.state.files.length > 0 && <button className="btn btn-default" onClick={this.onCancel.bind(this)}>Clear</button>}{` `} */}
                                  </div>
                                )}
                              </div>
                            </Modal.Body>
                            <Modal.Footer>
                              <button
                                type="button"
                                className="btn btn-default"
                                data-dismiss="modal"
                                onClick={this.closeModal.bind(this)}
                                disabled={isFilesUploading}
                              >
                                Cancel
                          </button>
                              <button
                                type="button"
                                className="btn btn-primary"
                                disabled={this.state.files.length === 0}
                                onClick={this.onStartUpload.bind(this)}
                              >
                                Upload Files
                          </button>
                            </Modal.Footer>
                            {isFilesUploading && (
                              <div className="cover">
                                <div className="spinner" />
                              </div>
                            )}
                          </Modal>
                          <div className="col-sm-6">
                            <div className="row">
                              <div className="col-sm-6">
                                <h1>
                                  {userInfo.firstName} <span className="semi-bold">{userInfo.lastName}</span>
                                  <br />
                                  <small> {userInfo.roles.map(el => el.name).join()}</small>
                                </h1>
                              </div>
                              <div className="col-sm-3">
                              </div>
                              <div className="col-sm-3">
                                {isSuperAdmin && (
                                  <TenantDropdown
                                    tenants={tenants}
                                    user={this.props.user}
                                    changeTenant={changeTenant}
                                  />
                                )}
                              </div>
                            </div>
                            
                            <ul className="list-unstyled">
                              <li>
                                <p className="text-muted">
                                  <i className="fa fa-envelope" />
                                  &#xA0;&#xA0;
                                  <a href={`mailto:${userInfo.email}`}>
                                    {userInfo.email}
                                  </a>
                                </p>
                              </li>
                              <li>
                                <p className="text-muted">
                                  <i className="fa fa-fw fa-building-o" />
                                  &#xA0;&#xA0;
                                  <span className="txt-color-darken">Wellness for Life</span>{' '}
                                </p>
                              </li>
                              {primaryClinic &&
                                <li>
                                  <p className="text-muted">
                                    <i className="fa fa-fw fa-hospital-o" />
                                    &#xA0;&#xA0;
                                    <span className="txt-color-darken">{primaryClinic}</span>{' '}
                                  </p>
                                </li>
                              }
                              {otherClicnics &&
                                <li>
                                  <p className="text-muted">
                                    <i className="fa fa-fw fa-hospital-o" />
                                    &#xA0;&#xA0;
                                    <span className="txt-color-darken">{otherClicnics}</span>{' '}
                                  </p>
                                </li>
                              }
                              {clients &&
                                <li>
                                  <p className="text-muted">
                                    <i className="fa fa-fw fa-users" />
                                    &#xA0;&#xA0;
                                    <span className="txt-color-darken">{clients}</span>{' '}
                                  </p>
                                </li>
                              }
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <div className="col-sm-6 col-sm-offset-3">
                          <br />
                          <span className="txt-color-darken"><strong>Note:</strong> User profile information is managed by your organizational Microsoft account.
                            If you see an error or information that needs to be updated, please submit a support ticket to Platform Applications
                            at <a href={`https://members.proactive-md.com/portal/`} target="_blank">https://members.proactive-md.com/portal/</a>
                          </span>{' '}
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <div className="col-sm-6 col-sm-offset-3">
                          <LayoutSwitcher />
                        </div>
                      </div>

                      {/*
                      <div className="col-sm-12">
                        <CSSView cssText={userInfo.cssText} onFormSubmit={this.onFormSubmit} isLoading={isLoading} />
                      </div>
                      */}
                      {isSuperAdmin && (
                        <div className="col-sm-12">
                          <WidgetGrid>
                            <JarvisWidget
                              color="white"
                              fullscreenbutton={true}
                              colorbutton={false}
                              closeButton={true}
                              editbutton={false}
                              togglebutton={false}
                              deletebutton={false}
                            >
                              <div>
                                <div className="widget-body">
                                  <CSSForm
                                    onSubmit={this.onFormSubmit}
                                  />
                                  {(isLoading) && (
                                    <div className="spinner hide" />
                                  )}
                                </div>
                              </div>
                            </JarvisWidget>
                          </WidgetGrid>
                        </div>
                        )
                      }
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(
  state => ({
    user: state.currentUser,
    tenants: state.tenant.list,
    isSuperAdmin: isSuperAdmin(state),
  }),
  dispatch => ({
    uploadFiles: (userId, files) =>
      dispatch(uploadUserFiles(userId, files)),
    getUserFile: (userId, file) =>
      dispatch(getUserFile(userId, file)),
    updateCss: (assetId, css) =>
      dispatch(updateCss(assetId, css)),
    getTenants: () => dispatch(requestTenants()),
    changeTenant: (id) => dispatch(changeTenant(id)),
  }),
)(Profile);



// WEBPACK FOOTER //
// ./src/routes/my/containers/Profile.js